import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import SumaContexto from '../../contexto/SumaContexto';
import queryString from 'query-string';
import ServicioUsuarios from '../../servicios/usuarios/ServicioUsuarios'
import { Spin, Alert, Button, Modal, Form, Row, Col, Checkbox } from 'antd';
import Constantes from '../../utilidades/Constantes'
import Utilidades from '../../utilidades/Utilidades';
import { CheckSquareOutlined } from '@ant-design/icons';


function ValidarActivarDadepCuenta(attr) {
    if (attr.cargando) {
        return (
            <>
                <div className="titulo-seccion">
                    <label>ACTIVAR CUENTA DADEP</label>
                    <div className="separador-horizontal-completo"></div>
                </div>
                <div className="cargando-pagina">
                    <Spin tip="Por favor espera..." size="large" ></Spin>
                </div>
            </>
        )
    }

    if (!attr.activarCuenta) {
        return (
            <>
                <div>
                    <Alert message={attr.msgError} type="warning" />
                </div>
            </>
        );
    } else {

        return (
            <></>
        );
    }
}

class ActivarDadepCuenta extends Component {

    static contextType = SumaContexto;

    state = {
        cargando: true,
        msgError: null,
        activarCuenta: false,
    };

    constructor(props) {
        super(props);
        this.servicioUsuarios = new ServicioUsuarios(props);
    }

    formRef = React.createRef();

    async componentDidMount() {
        this._isMounted = true;
        let params = this.props.location.search;
        let urlparametros = queryString.parse(params);
        let msg, msgError = undefined;
        this.enc = null;
        if (urlparametros.enc !== undefined) {
            this.enc = urlparametros.enc;
            let respuestaApi = await this.servicioUsuarios.cuentaValidaParaActivar(this.enc);

            if (respuestaApi) {
                //console.log('respuestaApi: ', respuestaApi);
                switch (respuestaApi.codigo) {
                    case Constantes.ENUMS_API.USUARIO.OPERACION_REALIZADA.id:
                        this.setSumaState({
                            activarCuenta: true,
                            idUsuario: parseInt(respuestaApi.resultado),
                            usuarioInformacionBasicaDto: respuestaApi.resultado
                        });
                        break;
                    case Constantes.ENUMS_API.USUARIO.TOKEN_EXPIRADO.id:
                        msgError = 'El enlace no se encuentra activo para activar la cuenta. Debes solicitar o generar un nuevo correo de activación.';
                        Modal.warning({ content: msgError });
                        break;
                    case Constantes.ENUMS_API.USUARIO.OPERACION_NO_REALIZADA.id:
                        msgError = respuestaApi.mensaje;
                        Modal.warning({ content: msgError })
                        break;
                    default:
                        msgError = 'PETICIÓN NO DISPONIBLE';
                        break;
                }
                this.setSumaState({ cargando: false, msgError, msg });
            }
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }

    render() {

        const layout = {
            labelCol: {
                /*span: 10, offset: 2,*/
                sm: { span: 22, offset: 2 },
                md: { span: 12, offset: 2 },
                lg: { span: 12, offset: 2 },
                xl: { span: 10, offset: 2 }
            },
            wrapperCol: {
                sm: { span: 22, offset: 2 },
                md: { span: 10 },
                lg: { span: 10 },
                xl: { span: 12 },
            },
        };

        const onFinish = async (values) => {
            this.setSumaState({ cargando: true });
            // Contrasena nueva
            let respuestaApi = await this.servicioUsuarios.activarCuenta(
                {
                    aceptoTerminoscondiciones: values.terminosYCondiciones,
                },
                this.enc);

            if (respuestaApi) {
                let form = null;
                switch (respuestaApi.codigo) {
                    case Constantes.ENUMS_API.USUARIO.OPERACION_REALIZADA.id:
                        form = this.formRef.current;
                        if (form != null) {
                            form.resetFields();
                            this.setSumaState({ mostrarModal: true, });
                        }
                        break;
                    default:
                        Modal.error({ content: 'No fue posible activar la cuenta.' });
                        break;
                }

                setTimeout(() => { this.setSumaState({ cargando: false }); }, 500);
            }


        };

        const onFinishFailed = errorInfo => {
            Modal.warning({ content: 'Por favor diligencia la información solicitada.' });
        };

        return (
            <div className="seccion-principal seccion-flex">
                <div className="division-principal">
                    <label>Activar Cuenta Dadep</label>
                </div>
                <div className="division-contenido seccion-flex-grow-1 padding-principal bkg-white">
                    {!this.state.activarCuenta ?
                        <ValidarActivarDadepCuenta cargando={this.state.cargando}
                            activarCuenta={this.state.activarCuenta}
                            msgError={this.state.msgError}
                            token={this.enc}
                            msg={this.state.msg} />
                        : (<>

                            <Spin tip="Cargando..." size="large" spinning={this.state.cargando}>
                                <div className="titulo-seccion">
                                    <label>ACTIVAR CUENTA DADEP</label>
                                    <div className="separador-horizontal-completo"></div>
                                    <p className="descripcion-seccion">Para activar tu cuenta dentro del portal SUMA+ haz clic en el botón 'Activar Cuenta'</p>
                                    <br />
                                </div>
                                <div className="seccion-formulario">

                                    <Modal title="Importante" closable={false} className="modal-suma icono-con-texto"
                                        visible={this.state.mostrarModal}
                                        footer={[
                                            <Button key="cerrar" type="primary" href={Constantes.URL_PUBLICAS.INICIO} >
                                                Cerrar
                                            </Button>
                                        ]}
                                    >
                                        <CheckSquareOutlined />
                                        <p>
                                            Tu usuario ha sido activado, ahora puedes ingresar al portal SUMA+ con tus credenciales de acceso.
                                        </p>
                                    </Modal>

                                    <Form
                                        {...layout}
                                        ref={this.formRef}
                                        name="asignar-contrasena"
                                        className="formulario-suma"
                                        scrollToFirstError
                                        onFinish={onFinish}
                                        onFinishFailed={onFinishFailed}
                                    >

                                        {(this.state.usuarioInformacionBasicaDto && this.state.usuarioInformacionBasicaDto.debeAceptarTerminosCondiciones) ?
                                            <Row>
                                                <Col xs={24} >
                                                    <Form.Item name="terminosYCondiciones"
                                                        valuePropName="checked"
                                                        rules={[
                                                            {
                                                                validator: (_, value) =>
                                                                    value ? Promise.resolve() : Promise.reject(new Error('Debes aceptar los términos y condiciones')),
                                                            },]}
                                                        labelCol={{ span: 24, offset: 0 }}
                                                        wrapperCol={{ span: 24, offset: 0 }}>
                                                        <Checkbox>
                                                            Acepto los <a href={Utilidades.extraerEnlace(Constantes.ENUMS.PARAMETRO_GENERAL.ENLACE_TERMINOS_Y_CONDICIONES.id)}>términos y condiciones</a> y la
                                                            <a href={Utilidades.extraerEnlace(Constantes.ENUMS.PARAMETRO_GENERAL.ENLACE_PROTECCION_DATOS_PERSONALES.id)}> política de protección de datos personales</a>
                                                        </Checkbox>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            : null
                                        }

                                        <Form.Item>
                                            <Button type="primary" htmlType="submit" loading={this.state.cargando}>
                                                Activar cuenta
                                            </Button>
                                        </Form.Item>

                                    </Form>





                                </div>

                            </Spin>

                        </>)
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(ActivarDadepCuenta);